import { View, Text, Pressable, Platform } from 'react-native';
import type { Ref } from 'react';
import { WEB_HOVER_TRANSITION_STYLE } from '../../../src/shared/constants/animations';
import { getInlineMarketPickerStyles } from './InlineMarketPicker.styles';

const styles = getInlineMarketPickerStyles();

export interface OddsTileProps {
  label: string;
  sub?: string;
  odd: number;
  pct?: number;
  selected: boolean;
  onPress: () => void;
  /** Optional ref to the underlying pressable — used by the guest walkthrough to spotlight a specific tile. */
  tileRef?: Ref<View>;
}

export function OddsTile({ label, sub, odd, pct, selected, onPress, tileRef }: OddsTileProps) {
  return (
    <Pressable
      ref={tileRef}
      style={({ pressed }) => [
        styles.tile,
        selected && styles.tileSelected,
        Platform.select({ web: WEB_HOVER_TRANSITION_STYLE }),
        pressed && styles.tilePressed,
      ]}
      onPress={onPress}
      accessibilityRole="button"
      accessibilityState={{ selected }}
      accessibilityLabel={`${label} ${odd.toFixed(2)}`}
    >
      <Text style={[styles.tileLabel, selected && styles.tileLabelSelected]} numberOfLines={1}>
        {label}
      </Text>
      {sub != null && (
        <Text style={[styles.tileSub, selected && styles.tileSubSelected]} numberOfLines={1}>
          {sub}
        </Text>
      )}
      <Text style={[styles.tileOdds, selected && styles.tileOddsSelected]} numberOfLines={1}>
        {odd.toFixed(2)}
      </Text>
      {pct != null && (
        <View style={[styles.communityBar, { width: `${pct}%` as unknown as number }]} />
      )}
    </Pressable>
  );
}
